module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/live-yellow-4759e2696f1982351d18d263b73820b5.gif";